<ng-template #Modal let-data let-ref="dialogRef">
  <nb-card class="staffInfoTemplate" *ngIf="info.moType==1">
    <nb-card-header>
      {{ 'posOrder_add_announcement' | translate }}
    </nb-card-header>
    <nb-card-body>
      <div class="row">
        <div class="row mx-0 col-lg-12">
          <label class="label col-sm-12 col-form-label">{{ 'posOrder_content' | translate }}</label>
          <textarea
            name="Announcement"
            rows="5"
            type="text"
            nbInput
            fullWidth
            [(ngModel)]="announcement"
            maxlength="4000">
          </textarea>
        </div>
      </div>

      <div class="row">
        <ng-container>
          <div class="row mx-0 col-lg-12">
            <label class="label col col-form-label text-nowrap">{{ 'posOrder_select_announcement_store' | translate }}</label>
            <div class="w-100 mt-2">
              <table class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>{{ 'common_store' | translate }}</th>
                    <th>{{ 'common_display' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ 'common_all' | translate }}</td>
                    <td>
                      <nb-toggle status="info" [(checked)]="isSelectAll" (change)="toggleSelectAll()"></nb-toggle>
                    </td>
                  </tr>
                  <ng-container *ngFor="let e of mainDataList">
                    <tr>
                      <td>{{ e.content }}</td>
                      <td>
                        <nb-toggle status="info" [(checked)]="e.isChecked" (change)="onStoreToggle()"></nb-toggle>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </div>
        </ng-container>
      </div>
    </nb-card-body>
    <nb-card-footer>
      <button nbButton (click)="onSave();">{{ 'common_confirm' | translate }}</button>
      <button nbButton (click)="ref.close()">{{ 'common_cancel' | translate }}</button>
    </nb-card-footer>
  </nb-card>

  <nb-card class="staffInfoTemplate" *ngIf="info.moType==2">
    <nb-card-header>
      {{ 'common_view' | translate }}{{ 'posOrder_add_announcement' | translate }}
    </nb-card-header>
    <nb-card-body>
      <div class="row">
        <div class="row mx-0 col-lg-12">
          <label class="label col-sm-12 col-form-label">{{ 'posOrder_content' | translate }}</label>
          <textarea
            name="Announcement"
            rows="5"
            type="text"
            nbInput
            fullWidth
            [(ngModel)]="orgData.announcementDetail.Announcement"
            maxlength="4000"
            disabled>
          </textarea>
        </div>
      </div>

      <div class="row">
        <div class="row mx-0 col-lg-12">
          <label class="label col-sm-12 col-form-label">{{ 'posOrder_select_announcement_store' | translate }}</label>
          <span>{{ orgData.announcementDetail.StoreDTOs }}</span>
        </div>
      </div>
    </nb-card-body>
    <nb-card-footer>
      <button nbButton (click)="ref.close()">{{ 'common_close' | translate }}</button>
    </nb-card-footer>
  </nb-card>
</ng-template>
